import API from '@/assets/js/libs/API'

export default {
  getPositionList: () => API.get('position'),
  addNewPosition: (positionObj) => API.post('position', positionObj),
  updatePosition: (id, positionObj) =>
    API.put(`position/?id=${id}`, positionObj),
  deletePosition: (id) => API.delete(`position/?id=${id}`),
}



// WEBPACK FOOTER //
// ./src/API/positionService.js